import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/pages/home.css";
import chef from "../media/chef.jpeg";
import join from "../media/join.jpeg";
import eater from "../media/eater.jpeg";
import tog2 from "../media/tog-icon2.png";
import tog3 from "../media/tog-icon-3.png";
import hand from "../media/hand.svg";
import Reviews from "../components/Reviews";
import Faqs from "../components/Faqs";
import { Link } from "react-router-dom";

const Home = () => {
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", desc: "" });

  const toggleModal = () => setModal(!modal);

  const openModal = (item) => {
    setModalContent(item);
    setModal(true);
  };

  const content = [
    {
      link: "/eater-cheffy",
      img: eater,
      title: "Eater en Cheffy",
      desce:
        "¡Descubre una nueva forma de disfrutar comidas deliciosas, preparadas por chefs, en la comodidad...",
      desc: (
        <>
          <p>
            ¡Descubre una nueva forma de disfrutar comidas deliciosas,
            preparadas por chefs, en la comodidad de tu hogar con Cheffy!
            Convertirte en Eater es fácil y te abre las puertas a experiencias
            gastronómicas personalizadas y de alta calidad, todo a precios
            accesibles. Así es como puedes comenzar:
          </p>
          <ol>
            <li>
              <strong>Descarga la App de Cheffy:</strong> Comienza descargando
              nuestra aplicación, disponible para iOS y Android, para explorar
              un mundo de opciones culinarias diseñadas especialmente para ti.
            </li>
            <br />
            <li>
              <strong>Crea Tu Perfil:</strong> Configura tus preferencias para
              ayudar a los chefs a conocer tus gustos. Ya sea que tengas antojo
              de un banquete gourmet, sabores locales, opciones de meal prep o
              platillos para llenar tus tuppers de la semana, hay chefs listos
              para crear lo que deseas.
            </li>
            <br />
            <li>
              <strong>Publica Tu Solicitud de Comida:</strong> ¡Lanza tu oferta! Describe qué
              estás buscando, fija tu presupuesto y deja que chefs talentosos
              pujen para hacer realidad tu visión. Tendrás la libertad de elegir
              un chef según las reseñas, especialidades y precio, asegurándote
              de obtener la comida perfecta al mejor valor.
            </li>
            <br />
          
           
          </ol>
          {/* <p>
            With Cheffy, you can have a gourmet experience at an affordable
            price, with real chefs bringing the restaurant to your home.
            Download the app today on iOS or Android and become an Eater on
            Cheffy—where every meal is a unique experience!
          </p> */}
        </>
      ),
    },

    {
      link: "/cooker-cheffy",
      img: chef,
      title: "Cooker en Cheffy",
      desce:
        "¿Listo para compartir tu talento culinario y ganar dinero cocinando para otros? Convertirte en Cooker en Cheffy...",
      desc: (
        <>
          <p>
            Ready to share your culinary talent and earn money by cooking for
            others? Becoming a Cooker on Cheffy is simple, secure, and
            rewarding!
          </p>
          <ol>
            <li>
              <strong>Sign Up and Verify Your Identity:</strong> Ensure a safe
              and trustworthy experience by providing personal identification
              (e.g., DNI or driver’s license). This step helps keep the Cheffy
              community secure.
            </li>
            <li>
              <strong>Add Your Bank Account:</strong> Link your bank account to
              receive payments directly and securely for every meal you cook.
            </li>
            <li>
              <strong>Start Cooking:</strong> Complete your profile, explore
              meal requests from Eaters, and begin creating delicious dishes
              that people will love.
            </li>
          </ol>
          <p>
            With Cheffy, you can turn your passion for cooking into a fulfilling
            opportunity to share your skills and earn money. Get started today!
          </p>
        </>
      ),
    },
    // {
    //   img: tog3,
    //   title: "Security",
    //   desce:
    //     "At Cheffy, your security is our top priority. We ensure that all payments are processed through a secure,",

    //   desc: (
    //     <>
    //       <p>
    //         At Cheffy, your security is our top priority. We use secure,
    //         encrypted payment processing to protect your financial information
    //         at every step.
    //       </p>
    //       <p>
    //         For Cookers, payments from Eaters are deposited directly and
    //         securely into your linked bank account—no intermediaries or waiting
    //         periods. This ensures you receive your earnings promptly and safely.
    //       </p>
    //       <p>
    //         With Cheffy, you can focus on creating amazing meals while we handle
    //         the security of every transaction.
    //       </p>
    //     </>
    //   ),
    // },
    {
      link: "/join-us",
      img: join,
      title: "Trabaja Con Nosotros",
      desce:
        "En Cheffy, siempre estamos buscando personas apasionadas para unirse a nuestro equipo. ¡Nos encantaría... ",
      desc: (
        <>
          <p>
            At Cheffy, we’re always looking for passionate individuals to join
            our vibrant community! Whether you’re a talented Cooker sharing your
            culinary skills or interested in supporting our platform as part of
            our dedicated team, we’d love to have you on board.
          </p>
          <br />
          <p>
            To apply, simply fill out the application form, attach your CV, and
            share a brief description of why you’d be a perfect fit for Cheffy.
            Your unique experiences and enthusiasm are what make our platform
            exceptional, and we’re excited to hear from you!
          </p>
        </>
      ),
    },
  ];

  return (
    <>
      <Header />
      <section className="together-section">
        <img src={hand} alt="Together section" className="tog-sec-img" />
        <h2 className="section-head">Hagámoslo juntos</h2>
        <div className="tog-row">
          {content.map((item, index) => (
            <div key={index} className="tog-row-col">
              <span className="tog-img-container">
                <img src={item.img} alt="Icon" className="tog-img" />
              </span>
              <h3 className="tog-col-head">{item.title}</h3>
              <p className="tog-col-desc">
                {typeof item.desce === "string"
                  ? item.desce.split(" ").slice(0, 15).join(" ") + "..."
                  : "Click + info for details..."}
              </p>
              <Link to={item.link}>
                <Button
                  className="tog-col-button"
                  onClick={() => openModal(item)}
                >
                  + info
                </Button>
              </Link>
            </div>
          ))}
        </div>
      </section>
      <section className="reviews">
        <h2 className="section-head">Experiencias sobre Cheffy</h2>
        <Reviews />
        <div class="custom-shape-divider-top-1733597310">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z"
              class="shape-fill"
            ></path>
          </svg>
        </div>
      </section>

      <section className="faqs">
        <h2 className="section-head">Preguntas frecuentes</h2>
        <Faqs />

        <div class="custom-shape-divider-top-1733643358">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
              class="shape-fill"
            ></path>
          </svg>
        </div>
      </section>

      {/* Modal */}
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>{modalContent.title}</ModalHeader>
        <ModalBody className="modal-body">{modalContent.desc}</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Home;
